<template>
  <section id="nav-apps">
    <div class="links-header heavy margin-bottom-xs">Download the {{ title }} App</div>

    <ul class="nav-app-list grid-x align-middle">
      <li v-for="item in appLinks" :key="item.title">
        <CommonLink :href="item.link" :title="item.title">
          <Picture :image-url="getAssetImage(item.img)" :using-scene7="false" alt="" />
        </CommonLink>
      </li>
    </ul>
  </section>
</template>

<script setup>
import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';
import getAssetImage from '~/utils/getAssetImage';

import { appLinks } from 'config';

defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>

<style lang="scss">
$appImgHeight: 40px;

.nav-app-list {
  gap: map-get($grid-margin-gutters, 'large');

  picture {
    display: block;
    height: $appImgHeight;
  }

  img {
    height: 100%;
  }
}
</style>

<style lang="scss" brand="mcom">
#nav-apps {
  .links-header {
    color: $white;
  }
}
</style>
